import { render, staticRenderFns } from "./TranslationLevel.vue?vue&type=template&id=0cd19aca&scoped=true&"
import script from "./TranslationLevel.vue?vue&type=script&lang=js&"
export * from "./TranslationLevel.vue?vue&type=script&lang=js&"
import style0 from "./TranslationLevel.vue?vue&type=style&index=0&id=0cd19aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd19aca",
  null
  
)

export default component.exports